<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12">
                <div class="d-inline">
                  <h2 class="text-md-h4 font-weight-bold">
                    {{ username }}
                  </h2>
                  <span class="text-subtitle-1">
                    NIP. {{ usernik }}
                  </span>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-tabs
                  v-model="tabdata"
                  show-arrows>
                  <v-tabs-slider :color="maincolor"></v-tabs-slider>
                  <v-tab href="#acc" active-class="main-style-slide">
                    Summary Remunerasi
                  </v-tab>
                  <v-tab href="#pengajaran" active-class="main-style-slide">
                    Pengajaran
                  </v-tab>
                  <v-tab href="#peneliti" active-class="main-style-slide">
                    Penelitian
                  </v-tab>
                  <v-tab href="#pengabdian" active-class="main-style-slide">
                    Pengabdian
                  </v-tab>
                  <v-tab href="#pendukung" active-class="main-style-slide">
                    Pendukung
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items :touchless="true" v-model="tabdata">
                  <v-tab-item value="acc">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Profile
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Status</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              Dosen Biasa
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Jabatan</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              Lektor Kepala
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Harga Jabatan</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              Rp. 1.167.210
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Summary Perhitungan
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      No
                                    </th>
                                    <th class="text-left">
                                      Komponen Kinerja
                                    </th>
                                    <th class="text-left">
                                      Poin Normal
                                    </th>
                                    <th class="text-left">
                                      Realisasi
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>Kehadiran >= 20 hari per bulan (max)</td>
                                    <td>2</td>
                                    <td>2</td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>Pelaksanaan Tridharma (min)</td>
                                    <td>2</td>
                                    <td>40</td>
                                  </tr>
                                  <tr>
                                    <td>3</td>
                                    <td>Sikap dan perilaku (max)</td>
                                    <td>2</td>
                                    <td>2</td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>Total Konerja Realisasi</td>
                                    <td></td>
                                    <td><b>44</b></td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>Total Remunerasi Per Semester</td>
                                    <td></td>
                                    <td><b>Rp. 51.357.240</b></td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>Total Remunerasi P1 yang sudah dibayar</td>
                                    <td></td>
                                    <td><b>Rp. 14.006.520</b></td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>Kurang Bayar</td>
                                    <td></td>
                                    <td><b>Rp. 37.350.720</b></td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Detail data kehadiran
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      Bulan
                                    </th>
                                    <th class="text-left">
                                      Jumlah kehadiran
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>09-2023</td>
                                    <td>8</td>
                                  </tr>
                                  <tr>
                                    <td>10-2023</td>
                                    <td>0</td>
                                  </tr>
                                  <tr>
                                    <td>11-2023</td>
                                    <td>0</td>
                                  </tr>
                                  <tr>
                                    <td>12-2023</td>
                                    <td>0</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Pelaksanaan Tridharma
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      No
                                    </th>
                                    <th class="text-left">
                                      Aktivitas
                                    </th>
                                    <th class="text-left">
                                      Satuan
                                    </th>
                                    <th class="text-left">
                                      Jumlah
                                    </th>
                                    <th class="text-left">
                                      Poin
                                    </th>
                                    <th class="text-left">
                                      Realisasi
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>Mengajar program D3/S1</td>
                                    <td>Jam</td>
                                    <td>68</td>
                                    <td>0.5</td>
                                    <td>34</td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>Membimbing Tugas Akhir (TA) s.d. Lulus</td>
                                    <td>Mahasiswa</td>
                                    <td>6</td>
                                    <td>0.24</td>
                                    <td>1.44</td>
                                  </tr>
                                  <tr>
                                    <td>3</td>
                                    <td>Menguji proposal skripsi/TA</td>
                                    <td>Mahasiswa</td>
                                    <td>8</td>
                                    <td>0.09</td>
                                    <td>0.72</td>
                                  </tr>
                                  <tr>
                                    <td>4</td>
                                    <td>Menguji pada LSP</td>
                                    <td>Mahasiswa</td>
                                    <td>5</td>
                                    <td>0.06</td>
                                    <td>0.3</td>
                                  </tr>
                                  <tr>
                                    <td>5</td>
                                    <td>Melakukan program pengabdian</td>
                                    <td>Kegiatan</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                  </tr>
                                  <tr>
                                    <td>6</td>
                                    <td>Melakukan program pelatihan</td>
                                    <td>Kegiatan</td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>2</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Capaian SKP
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      No
                                    </th>
                                    <th class="text-left">
                                      Aktivitas
                                    </th>
                                    <th class="text-left">
                                      Satuan
                                    </th>
                                    <th class="text-left">
                                      Poin
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Penilaian Sikap & Perilaku
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      Periode
                                    </th>
                                    <th class="text-left">
                                      Nilai
                                    </th>
                                    <th class="text-left">
                                      Poin
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>01-2024</td>
                                    <td>90</td>
                                    <td>2</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pengajaran">
                    <v-card flat v-if="listpengajaran">
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Pengajaran
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">NIDN</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengajaran.nidn }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Nama</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengajaran.nama }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Total SKS</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengajaran.totalSKS }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Detail Pengajaran
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-data-table
                              :headers="headerajar"
                              :items="listpengajaran.kelasPerkuliahaan"
                              :items-per-page.sync="itemsPerPageAjar"
                              :page.sync="curPageAjar"
                              :search="filterajar.search">
                              <template v-slot:[`item.no`]="{ index }">
                                {{ (curPageAjar - 1) * itemsPerPageAjar + index + 1 }}
                              </template>
                              <template v-slot:[`item.mataKuliah`]="{ item }">
                                <span
                                  :title="item.mataKuliah"
                                  class="d-inline-block text-truncate"
                                  style="max-width: 500px;">
                                  {{ item.mataKuliah ? item.mataKuliah : '-' }}
                                </span>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="peneliti">
                    <v-card flat v-if="listpenelitian">
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Penelitian
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">NIDN</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpenelitian.nidn }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Nama</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpenelitian.nama }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Total SKS</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpenelitian.totalSKS }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Detail Penelitian
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-data-table
                              :headers="headerpen"
                              :items="listpenelitian.dataPenelitan"
                              :items-per-page.sync="itemsPerPagePen"
                              :page.sync="curPagePen"
                              :search="filterpen.search">
                              <template v-slot:[`item.no`]="{ index }">
                                {{ (curPagePen - 1) * itemsPerPagePen + index + 1 }}
                              </template>
                              <template v-slot:[`item.judul`]="{ item }">
                                <span
                                  :title="item.judul"
                                  class="d-inline-block text-truncate"
                                  style="max-width: 500px;">
                                  {{ item.judul ? item.judul : '-' }}
                                </span>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pengabdian">
                    <v-card flat v-if="listpengabdian">
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Pengabdian
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">NIDN</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengabdian.nidn ? listpengabdian.nidn : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Nama</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengabdian.nama ? listpengabdian.nama : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Total SKS</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ listpengabdian.totalSKS ? listpengabdian.totalSKS : '-' }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Detail Pengabdian
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-data-table
                              :headers="headerpeng"
                              :items="listpengabdian.dataPenelitan"
                              :items-per-page.sync="itemsPerPagePeng"
                              :page.sync="curPagePeng"
                              :search="filterpeng.search">
                              <template v-slot:[`item.no`]="{ index }">
                                {{ (curPagePeng - 1) * itemsPerPagePeng + index + 1 }}
                              </template>
                              <template v-slot:[`item.judul`]="{ item }">
                                <span
                                  :title="item.judul"
                                  class="d-inline-block text-truncate"
                                  style="max-width: 420px;">
                                  {{ item.judul ? item.judul : '-' }}
                                </span>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pendukung">
                    <v-card flat v-if="listpengabdian">
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Pendukung
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">NIP</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ usernik }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Nama</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ username }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Total Poin</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ tppendukung }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Detail Data Pendukung
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-data-table
                              :headers="headerpend"
                              :items="listpendukung"
                              :items-per-page.sync="itemsPerPage"
                              :page.sync="curPage"
                              :search="filterpend.search">
                              <template v-slot:[`item.no`]="{ index }">
                                {{ (curPage - 1) * itemsPerPage + index + 1 }}
                              </template>
                              <template v-slot:[`item.judul_sk`]="{ item }">
                                <span
                                  :title="item.judul_sk"
                                  class="d-inline-block text-truncate"
                                  style="max-width: 420px;">
                                  {{ item.judul_sk ? item.judul_sk : '-' }}
                                </span>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'Home',
  data: () => ({
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    apieof: process.env.VUE_APP_API_EOF,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    loading: {
      changedb: false,
      pendukung: false,
    },
    filter: {
      year: new Date().getFullYear(),
    },
    filterpend: {
      search: '',
    },
    filterpeng: {
      search: '',
    },
    filterpen: {
      search: '',
    },
    filterajar: {
      search: '',
    },
    datacard: {
      permohonan: 0,
      penilaian: 0,
      lulus: 0,
      gagal: 0,
    },
    btnto: 'SuratGuest',
    tabdata: 'profile',
    tahunaktif: '20252',
    listpendukung: [],
    listpengajaran: [],
    listpenelitian: [],
    listpengabdian: [],
    tppendukung: 0,
    headerpend: [
      { text: 'No', value: 'no' },
      { text: 'Ref.', value: 'no_sk' },
      { text: 'Tanggal', value: 'tgl_sk' },
      { text: 'Judul', value: 'judul_sk' },
      { text: 'Posisi', value: 'tim_role' },
      { text: 'Poin', value: 'tim_poin' },
    ],
    headerpeng: [
      { text: 'No', value: 'no' },
      { text: 'Judul', value: 'judul' },
      { text: 'Skema', value: 'tipe' },
      { text: 'SKS', value: 'sks' },
      { text: 'Posisi', value: 'posisi' },
    ],
    headerpen: [
      { text: 'No', value: 'no' },
      { text: 'Judul', value: 'judul' },
      { text: 'Skema', value: 'tipe' },
      { text: 'SKS', value: 'sks' },
      { text: 'Posisi', value: 'posisi' },
    ],
    headerajar: [
      { text: 'No', value: 'no' },
      { text: 'Matkul', value: 'mataKuliah' },
      { text: 'Kelas', value: 'kelas' },
      { text: 'SKS', value: 'sks' },
      { text: 'Target', value: 'target' },
      { text: 'Realisasi', value: 'realisasi' },
    ],
    itemsPerPage: 10,
    itemsPerPagePeng: 10,
    itemsPerPagePen: 10,
    itemsPerPageAjar: 10,
    curPage: 1,
    curPagePeng: 1,
    curPagePen: 1,
    curPageAjar: 1,
  }),
  created: () => ({
  }),
  mounted() {
    // for btn detail
    if (this.userrole === 'admin') {
      this.btnto = 'SuratAdmin';
    } else if (this.userrole === 'dosen') {
      this.btnto = 'SuratDosen';
    } else {
      this.btnto = 'SuratGuest';
    }
    // init request
    if (this.tokenscr) {
      this.updateChart();
    }
    this.getPengajaran();
    this.getPenelitian();
    this.getPengabdian();
    this.getPendukung();
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'username',
    ]),
    listyears() {
      const year = new Date().getFullYear();
      const lyear = Array.from({length: year - 2017}, (value, index) => 2018 + index);
      lyear.push('all');
      return lyear;
    },
  },
  methods: {
    resetDataCard() {
      this.datacard = {
        permohonan: 0,
        penilaian: 0,
        lulus: 0,
        gagal: 0,
      };
    },
    updateChart() {
      this.resetDataCard();
      if (this.tokenscr) {
        this.loading.changedb = true;
        this.axios
          .get(
            this.api + '/api/user/dashboard/beasiswa/' + this.filter.year,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datacard = resdata.data;
              }
              // console.log(this.datacard);
            }
            this.loading.changedb = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changedb = false;
          });
      }
    },
    getPendukung() {
      this.listpendukung = [];
      this.tppendukung = 0;
      if (this.tokenscr) {
        this.loading.pendukung = true;
        this.axios
          .get(
            this.apieof + '/api/sk/remun/tim',
            {
              params: {
                ta: this.tahunaktif,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listpendukung = resdata.data;
                resdata.data.forEach((element) => {
                  this.tppendukung += parseInt(element.tim_poin, 10);
                });
              }
            }
            this.loading.pendukung = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.pendukung = false;
          });
      }
    },
    getPengajaran() {
      this.listpengajaran = [];
      const strhex = this.tahunaktif +
        '' + '' +
        '' + '' +
        '' + this.usernik +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        Jurusan: '',
        Prodi: '',
        IDDosen: this.usernik,
        HashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/Pengajaran',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listpengajaran = resdata.dosen[0];
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPenelitian() {
      this.listpenelitian = [];
      const strhex = this.tahunaktif +
        '' + this.usernik +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.usernik,
        HashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/penelitian',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listpenelitian = resdata.dosen[0];
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPengabdian() {
      this.listpengabdian = [];
      const strhex = this.tahunaktif +
        '' + this.usernik +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.usernik,
        HashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/pengabdian',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listpengabdian = resdata.dosen[0];
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
